<!-- ================================================================================================
 =========================================DATA DINAMICA===================================================
===================================================================================================== -->
<template>
  <div
    class="container-fluid"
    style="padding: 0; margin: 0; width: 100vw"
    id="container_login"
  >
    <div class="row">
      <div class="col" style="padding: 0">
        <div class="container-fluid">
          <div
            class="row"
            id="section1"
            :style="`background-image:url(${
              esDemo
                ? 'https://lmsedk.com/site_new/assets/images/slider/3.png'
                : '/static/assets/img/bg1.jpg'
            })`"
          >
            <div class="container-fluid">
              <div class="row" id="contentTOP">
                <div class="container-fluid">
                  <div class="row justify-content-md-center" id="parentHeaders">
                    <div
                      class="col-lg-3 col-md-4 col-sm-5 col-xs-4"
                      id="header1"
                    >
                      <img
                        :src="
                          esDemo
                            ? 'https://lmsedk.com/site_v3/img/logo.png'
                            : '/static/assets/logo-header.png'
                        "
                        alt="logo-header"
                        id="logo-header"
                      />
                    </div>
                    <div
                      class="col-lg-8 col-md-7 col-sm-7 col-xs-8"
                      id="header2"
                    >
                      <a
                        :href="cia.home_faq_url"
                        target="_blank"
                        class="spanHeader"
                        style="margin-left: 20px"
                        :style="{'color': cia.home_faq_labels_color  + '!important'}"
                      >
                        {{cia['home_faq_label']}}
                      </a>
                      <a
                        :href="cia.home_software_requirements_url"
                        target="_blank"
                        class="spanHeader"
                        style="margin-left: 20px"
                        :style="{'color': cia.home_faq_labels_color  + '!important'}"
                      >
                        {{cia['home_software_requirements_label']}}
                      </a>
                      <a
                        :href="cia.home_contact_us_url"
                        target="_blank"
                        class="spanHeader"
                        style="margin-left: 20px"
                        :style="{'color': cia.home_faq_labels_color  + '!important'}"
                      >
                        {{cia['home_contact_us_label']}}
                      </a>
                    </div>
                  </div>
                  <div class="row justify-content-md-center" id="subHeader">
                    <div class="col-auto contenedorTitulosLogin">
                      <div
                        :class="[
                          'box', 'container-fluid',
                          { 'no-border': cia.home_show_bg_border === '1' ?  false : true}
                        ]">
                        <div class="top"></div>
                        <div class="bottom"></div>
                        <div class="left"></div>
                        <div class="right"></div>
                        <div class="row titleLoginContainer">
                          <h1>{{ cia['home_main_text'] }}</h1>
                        </div>
                      </div>
                      <div class="auth-box" v-bind:class="result">
                        <div
                          v-if="enMantenimiento"
                          class="contenedorLogin"
                          id="mantenimientoform"
                        >
                          <div class="mantenimiento-contenido">
                            <i class="fas fa-wrench mantenimiento-icono" aria-hidden="true"></i>
                            <span class="mantenimiento-titulo">
                              Plataforma en mantenimiento
                            </span>
                            <p class="mantenimiento-texto">
                              Estamos realizando mejoras.<br />
                              Regresamos en breve.
                            </p>
                          </div>
                        </div>
                        <div
                          v-if="mostrar1 && !enMantenimiento"
                          id="recoverform"
                          class="contenedorLogin"
                        >
                          <div id="contentSpanIngreseCuenta">
                            <h5 id="spanIngreseCuenta" class="">
                              Recuperar Contraseña
                            </h5>
                            <div class="container">
                              <div class="row">
                                <span id="spanIngreseCuentaTexto"
                                  >Ingresa tu email y CURP para enviarte las
                                  instrucciones!</span
                                >
                              </div>
                              <div class="row">
                                <span id="spanIngreseCuentaTexto"
                                  >Si eres un representante de empresa, debes
                                  ingresar tu ID de empresa y tu email.</span
                                >
                              </div>
                            </div>
                          </div>
                          <form
                            class="col-12"
                            v-on:submit.prevent="recuperarContrasena"
                          >
                            <div class="container-fluid" id="loginDiv">
                              <div
                                class="row"
                                style="
                                  padding-left: 10%;
                                  padding-right: 10%;
                                  padding-bottom: 30px;
                                "
                              >
                                <input
                                  class="textLoginPlaceholder"
                                  type="text"
                                  required
                                  placeholder="Email"
                                  style="box-shadow: none"
                                  title="Email"
                                  v-model="emailRC"
                                />
                                <h6>
                                  <small
                                    v-if="validacionCorreo"
                                    style="color: white"
                                    >El CORREO ingresado es incorrecto</small
                                  >
                                </h6>
                              </div>
                              <div
                                class="row"
                                style="
                                  padding-left: 10%;
                                  padding-right: 10%;
                                  padding-bottom: 30px;
                                "
                              >
                                <input
                                  class="textLoginPlaceholder"
                                  type="text"
                                  required
                                  placeholder="CURP / ID empresa"
                                  style="box-shadow: none"
                                  title="Curp"
                                  v-model="curpRC"
                                />
                                <h6>
                                  <small
                                    v-if="validacionCurp"
                                    style="color: white"
                                    >El CURP ingresado es incorrecto</small
                                  >
                                </h6>
                              </div>
                              <div class="row">
                                <div
                                  class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                  style="padding: 0px; padding-left: 10%"
                                >
                                  <button
                                    class="btn btnFullWhite"
                                    type="submit"
                                  >
                                    Enviar
                                  </button>
                                </div>
                                <div
                                  class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                  style="padding: 0px; padding-left: 5%"
                                >
                                  <button
                                    class="btn btnFullWhite"
                                    type="submit"
                                    v-on:click.prevent="regresarInicio"
                                  >
                                    Regresar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <!-- <div v-if="cia['home_show_register_section'] == '1'" class="contenedorLogin2" id="loginform">
                          <div class="nuevoDiv">
                            <div class=innerDiv>
                              <div class="mensaje">
                                  ¿Aún no tienes cuenta?
                              </div>
                              <div class="registro">
                                  <a @click="showRegisterModal">Regístrate aquí</a>
                              </div>
                            </div>
                          </div>
                        </div> -->

                        <div
                          v-if="mostrar && !enMantenimiento"
                          class="contenedorLogin"
                          id="loginform"
                        >
                          <div class="row" id="contentSpanIngreseCuenta">
                            <span id="spanIngreseCuenta"
                              >Ingresa a tu cuenta</span
                            >
                          </div>
                          <form
                            v-on:submit.prevent="Iniciar_Sesion"
                            id="loginform"
                          >
                            <input
                              name="__RequestVerificationToken"
                              type="hidden"
                              value="OHTz5bDiUfoY-GO10HHFKstq3fbeyWBQhqgUAgRijKwYs8i3pTSX04CYPdC9kYo-b0JU53PK2TF_LyQeHN41G-76HE2c65CP7rT0ovAU7Uo1"
                            />
                            <div
                              v-if="esDemo"
                              class="row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 10px;
                              "
                            >
                              <div class="form-group w-100">
                                <select
                                  class="
                                    form-control
                                    textLoginPlaceholder
                                    custom-select
                                  "
                                  v-model="clienteDemo"
                                  id="clienteFormControlSelect"
                                >
                                  <option
                                    class="
                                      textLoginPlaceholder
                                      optionLoginSelector
                                      active
                                    "
                                    value="null"
                                  >
                                    <h3>--SELECCIONA TU ENTIDAD--</h3>
                                  </option>
                                  <option
                                    class="
                                      textLoginPlaceholder
                                      optionLoginSelector
                                    "
                                    v-for="(cliente, index) in clientesDemo"
                                    :key="'cliente' + index"
                                    :value="cliente.cve_cliente"
                                  >
                                    {{ cliente.nombre_cliente }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              class="row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 30px;
                              "
                            >
                              <input
                                class="textLoginPlaceholder"
                                required
                                id="UserName"
                                name="UserName"
                                placeholder="CPF - CURP - CUI - CORREO ELECTRÓNICO"
                                style="box-shadow: none"
                                type="text"
                                value=""
                                title="Nombre de Usuario"
                                v-model="usuario"
                              />
                            </div>
                            <div
                              class="row d-flex flex-row"
                              style="
                                padding-left: 10%;
                                padding-right: 10%;
                                padding-bottom: 30px;
                              "
                            >
                              <input
                                class="textLoginPlaceholder1"
                                required
                                id="Password"
                                name="Password"
                                placeholder="Contraseña"
                                style="box-shadow: none"
                                type="password"
                                title="Contraseña"
                                v-model="password"
                              />
                              <button
                                class="btn"
                                type="button"
                                id="btn_Mostrar_Password"
                                @click="mostrarContrasena"
                              >
                                <i :class="icono_Pass"></i>
                              </button>
                            </div>

                            <div v-if="screenWidth < 450" class="d-flex flex-column justify-content-center align-items-center mb-2">

                              <div
                                class="col-auto mb-2"
                                style="
                                  padding-left: 0px;
                                  padding-right: 0px;
                                  text-align: center;
                                  color: white;
                                "
                              >
                                <a
                                  id="to-recover"
                                  class="spanLinkLogin"
                                  v-on:click.prevent="recoverPassword"
                                  >¿Olvidaste tu contraseña?</a
                                >
                              </div>
                              <div class="">
                                <button
                                  type="submit"
                                  class="btn btnFullWhite"
                                  id="btnIngresar"
                                >
                                  Ingresar
                                </button>
                              </div>
                            </div>
                            <div v-else class="row align-items-center mb-3">
                              <div
                                class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
                                style="padding: 0px; padding-left: 10%"
                              >
                                <button
                                  type="submit"
                                  class="btn btnFullWhite"
                                  style="width: 105px"
                                  id="btnIngresar"
                                >
                                  Ingresar
                                </button>
                              </div>
                              <div class="col" style="height: fit-content">
                                <div class="container">
                                  <div class="row justify-content-center">
                                    <div
                                      class="col-auto"
                                      style="
                                        padding-left: 0px;
                                        padding-right: 0px;
                                        text-align: center;
                                        color: white;
                                      "
                                    >
                                      <a
                                        id="to-recover"
                                        class="spanLinkLogin"
                                        v-on:click.prevent="recoverPassword"
                                        >¿Olvidaste tu contraseña?</a
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="height: 2px; background-color: rgba(0, 0, 0, .1); margin: 0 auto;"></div>

                            <div
                              v-if="screenWidth < 450"
                              class="d-flex flex-column justify-content-center align-items-center mb-2"
                            >
                              <div v-if="cia['home_show_register_section'] == '1'" style="color: white;">
                                  ¿Aún no tienes cuenta?
                              </div>
                              <div v-if="cia['home_show_register_section'] == '1'" class="registro">
                                  <a @click="showRegisterModal">Regístrate aquí</a>
                              </div>
                            </div>

                            <div
                              v-else
                              class="row"
                              style="margin-top: 3%; padding-left: 10%"
                            >
                              <div v-if="cia['home_show_register_section'] == '1'" style="color: white; margin-right: 30%">
                                  ¿Aún no tienes cuenta?
                              </div>
                              <div v-if="cia['home_show_register_section'] == '1'" class="registro">
                                  <a @click="showRegisterModal">Regístrate aquí</a>
                              </div>
                            </div>

                          </form>
                        </div>
                        <RestablecerUsuario
                          v-if="mostrar2 && !enMantenimiento"
                          :token="tokenRest"
                          @regresar="regresarInicio2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-white"></div>
          <div class="row contenedorMainFunctions" v-if="!esDemo">
            <div
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              style="padding: 0"
            >
              <div class="row" style="padding: 3% 0 3% 3%">
                <h5 id="spanFuncionesPrincipales">
                  {{cia['home_welcome_title']}}
                </h5>
              </div>
              <div
                class="col-lg-10 col-md-10 col-sm-12 col-xs-12"
                style="padding: 3%"
              >
                <span
                  class="subtitulos2"
                  id="spanAhoraDesde"
                  style="line-height: 25px; display: block"
                >
                  {{cia['home_welcome_text']}}
                </span>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              style="text-align: right"
            >
              <img
                src="/static/assets/img/mosaico.png"
                alt="Webservice Mobile"
                style="
                  width: 100%;
                  border-radius: 5px;
                  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.09);
                "
              />
            </div>
          </div>
          <div class="row contenedorConfiguracion" v-if="showConfigurationSection">
            <div class="row" style="padding-left: 0px; padding-right: 0px">
              <div
                class="col-lg-4 col-md-4 col-sm-6 col-xs-12 cuadrosText"
                v-for="(item, index) in configurationSectionContent" :key="index"
              >
                <div class="row" style="margin-bottom: 5%">
                  <h5
                    style="
                      color: #ff3300;
                      letter-spacing: normal;
                      line-height: 1;
                    "
                    id="h5Multiplataforma"
                  >
                    {{item.titulo}}
                  </h5>
                </div>
                <div class="row">
                  <span class="subtitulos2" id="spanMultiplataforma"
                    >{{item.contenido}}</span
                  >
                </div>
              </div>
            </div> </div>
          <div class="container-fluid backgroundNegro" :style="{ backgroundColor: cia.home_advantages_section_bg_color }" v-if="showAdvantagesSection">
            <div class="row" style="margin: 3vh; margin-left: 0px; padding: 0">
              <h5 class="ventajas" id="h5Ventas">{{cia.home_advantages_section_title}}</h5>
            </div>
            <div class="row" style="margin-top: 5vh; padding: 0">
              <div
                class="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                style="padding-right: 40px"
                v-for="(item, index) in advantagesSectionContent" :key="index"
              >
                <span
                  class="subtitulos"
                  id="spanOrdenes"
                  style="position: absolute"
                >
                  {{ item.subtitulo }}
                </span
                >
                <h5 class="textoAdvantages">{{item.titulo}}</h5>
                <span class="body3" id="spanSubOrdenes">
                  {{ item.contenido }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container-fluid contenedorFooter"
      v-if="!esDemo"
      style="width: 100%; padding: 2%"
    >
      <div class="row" style="padding-left: 3%; margin-top: 2%">
        <div
          class="col-lg-7 col-md-5 col-sm-12 col-xs-12"
          style="
            padding-left: 0px;
            line-height: 48px;
            text-align: left;
            padding-right: 0;
          "
        >
          <a
            :href="cia.home_faq_url"
            target="_blank"
            class="spanFooter"
            style="margin-left: 20px"
          >
            {{cia['home_faq_label']}}
          </a>
          <a
            :href="cia.home_software_requirements_url"
            target="_blank"
            class="spanFooter"
            style="margin-left: 20px"
          >
            {{cia['home_software_requirements_label']}}
          </a>
          <a
            :href="cia.home_contact_us_url"
            target="_blank"
            class="spanFooter"
            style="margin-left: 20px"
          >
            {{cia['home_contact_us_label']}}
          </a>
          <a
            :href="cia.terms_and_conditions_url"
            target="_blank"
            class="spanContactenosL spanFooter"
            style="margin-left: 20px"
          >
            Términos y condiciones
          </a>
          <a
            :href="cia.privacy_notice_url"
            target="_blank"
            class="spanContactenosL spanFooter"
            style="margin-left: 20px"
          >
            Aviso de privacidad
          </a>
        </div>
        <div
          class="
            col-lg-4 col-md-5 col-sm-8 col-md-offset-0 col-sm-offset-4 col-xs-12
          "
          style="padding-left: 0px; text-align: right"
        >
          <span
            style="
              display: inline-block;
              line-height: 50px;
              cursor: initial;
              font-size: 14px;
              font-family: 'Trade Gothic LT';
            "
            >{{ cia.home_copyright_text }} {{getCurrentYear()}}</span
          >
          <img
            class="logo-footer"
            src="/static/assets/logo_footer.png"
            alt="logo-footer"
            style="margin-left: 40px"
          />
          <a
            :href="cia.home_powered_url"
            target="_blank"
            style="
              color: white;
              line-height: 50px;
              cursor: pointer;
              font-size: 14px;
              font-family: 'Trade Gothic LT';
              position: absolute;
              width: fit-content;
              height: 1em;
              top: 3em;
              right: 1em;
            "
            id="textMARK"
            >powered by LMSEDK®</a
          >
        </div>
        <div
          v-if="cia.home_show_disclaimer_section == '1' ? true : false"
          class="disclaimer"
        >
          <span>{{ cia.home_disclaimer_text }}</span>
        </div>
      </div>
      <div>

        <b-modal ref="my-modal" id="modal-center" size="xl" hide-backdrop centered title="BootstrapVue" >

          <template #modal-header="{ close }">
            <h5>Registro</h5>
          </template>

          <div>
            <span class="ml-2">
              {{ cia.register_modal_text }}
            </span>
          </div>
          <div v-if="cia.register_modal_video_tutorial_text != ''">
            <button @click="openModal(cia.register_modal_video_link)" type="button" class="btn btn-link">{{cia.register_modal_video_tutorial_text}}</button>
          </div>
          <br>
          <form ref="myForm" id="register" @submit.prevent="crearUsuario" novalidate>
            <div class="row">
              <div class="col-6 form-group mb-3">
                <label for="nombre">Nombre y Apellidos</label>
                <input
                  type="text"
                  class="form-control modal-registro"
                  id="nombre_empleado"
                  v-model="nombre_empleado"
                  required
                  autocomplete="off"
                />
              </div>
              <div v-if="n2_array.length > 0" class="col-6 form-group mb-3">
                <label for="nombre">Segmento</label>
                <select
                  class="custom-select"
                  v-model="estructura.n2"
                  @change="onN2Change($event)"
                  required
                >
                  <option
                    value=""
                    :key="'estructura-n2-seleccione'"
                  >
                    --Seleccione--
                  </option>
                  <option
                    :value="n2.value"
                    :key="'estructura' + index + 'n2'"
                    v-for="(n2, index) in n2_array"
                  >
                    {{ n2.label }}
                  </option>
                </select>
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Tipo de cliente</label>
                <select
                  class="custom-select"
                  v-model="estructura.n3"
                  @change="onN3Change($event)"
                  :disabled="estructura.n2 == ''"
                  required
                >
                  <option
                    value=""
                    :key="'estructura-n3-seleccione'"
                  >
                    --Seleccione--
                  </option>
                  <option
                    :value="n3.value"
                    :key="'estructura' + index + 'n3'"
                    v-for="(n3, index) in n3_array"
                  >
                    {{ n3.label }}
                  </option>
                </select>
              </div>


              <div class="col-6 form-group mb-3">

                <!-- <label for="nombre">Empresa</label>
                <input
                  type="text"
                  class="form-control"
                  id="nombre_empleado"
                  v-model="estructura.n4"
                  required
                /> -->

                 <div class="autocomplete-container">
                  <label for="nombre">Empresa</label>
                  <input
                    type="text"
                    class="form-control modal-registro"
                    id="nombre_empleado"
                    v-model="estructura.n4"
                    @input="onN4Change"
                    required
                    :disabled="estructura.n3 == ''"
                    autocomplete="off"
                  />

                  <!-- Lista de sugerencias -->
                  <ul v-if="showSuggestions && filteredOptions.length" class="suggestions">
                    <li v-for="(option, index) in filteredOptions" :key="index" @click="selectOption(option)">
                      {{ option.label }}
                    </li>
                  </ul>
                  <ul v-if="showSuggestions && filteredOptions.length == 0" class="suggestions">
                    <li class="text-danger">
                      No hay resultados
                    </li>
                  </ul>
                </div>
                <!-- <label for="nombre">Empresa</label>
                <select
                  class="custom-select"
                  v-model="estructura.n4"
                  @change="onN4Change($event)"
                  :disabled="estructura.n3 == ''"
                >
                  <option
                    value=""
                    :key="'estructura-n4-seleccione'"
                  >
                    --Seleccione--
                  </option>
                  <option
                    :value="n4.value"
                    :key="'estructura' + index + 'n4'"
                    v-for="(n4, index) in n4_array"
                  >
                    {{ n4.label }}
                  </option>
                </select> -->
              </div>

              <div class="col-6 form-group mb-3">
                <label for="nombre">Puesto</label>
                <select
                  class="custom-select"
                  v-model="estructura.puesto"
                  :disabled="!showPuestos"
                  required
                >
                  <option
                    value=""
                    :key="'estructura-puesto-seleccione'"
                  >
                    --Seleccione--
                  </option>
                  <option
                    :value="puesto.value"
                    :key="'estructura' + index + 'puesto'"
                    v-for="(puesto, index) in puestos"
                  >
                    {{ puesto.label }}
                  </option>
                </select>
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Estado</label>
                <select
                  class="form-control"
                  v-model="estado"
                  id="estado"
                  required
                >
                  <option :value="null">-- SELECCIONA UN ESTADO --</option>
                  <option
                    v-for="(estado, index) of cia.estados"
                    v-bind:value="estado.cve_estado"
                    :key="`estado${index}`"
                  >
                    {{ estado.estado }}
                  </option>
                </select>
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Teléfono</label>
                <input
                  type="text"
                  class="form-control modal-registro"
                  id="telefono"
                  v-model="telefono"
                  @keypress="onlyNumbers"
                  required
                  autocomplete="off"
                />
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">CURP</label>
                <input
                  type="text"
                  class="form-control modal-registro"
                  id="curp"
                  v-model="curp"
                  required
                  maxlength="18"
                  placeholder="Ej. XXXX999999XXXXXXXX"
                  @input="validarSoloAlfanumerico('curp')"
                />
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">RFC</label>
                <input
                  type="text"
                  class="form-control modal-registro"
                  id="rfc"
                  v-model="rfc"
                  required
                  maxlength="13"
                  autocomplete="off"
                  placeholder="Ej. XXXX999999XXX"
                  @input="validarSoloAlfanumerico('rfc')"
                />
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Correo</label>
                <input
                  type="email"
                  class="form-control modal-registro"
                  id="correo"
                  v-model="correo"
                  required
                  autocomplete="off"
                  placeholder="Ej. correo@tudominio.com"
                />
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Fecha de nacimiento</label>
                <input
                  type="date"
                  class="form-control modal-registro"
                  id="fechaNacimiento"
                  v-model="fechaNacimiento"
                  required
                />
              </div>
              <div class="col-6 form-group mb-3">
                <label for="nombre">Género</label>
                <select
                  class="form-control"
                  v-model="genero"
                  id="genero"
                  required
                >
                  <option :value="null">-- SELECCIONA UN GÉNERO--</option>
                  <option value="H">
                    Hombre
                  </option>
                  <option value="M">
                    Mujer
                  </option>
                </select>
              </div>

            </div>
          </form>
          <template #modal-footer="{ ok, cancel }">
            <div v-if="!isFormValid" class="mr-auto">
              <strong class="text-danger text-uppercase">Todos los campos son obligatorios</strong>
            </div>
            <button
              class="btn btn-danger"
              @click="cancel()"
            >
              <span>Cancelar</span>
            </button>
            <button
              type="submit"
              class="btn btn-success"
              @click="crearUsuario"
              v-if="isFormValid"
            >
              <span> Registrar</span>
            </button>
            <!-- <button
              type="submit"
              class="btn btn-success"
              v-else
            >
            <span>Espere...</span>
            </button> -->
          </template>
        </b-modal>
      </div>

    </div>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import { mapActions } from "vuex";
import RestablecerUsuario from "./RestablecerUsuario.vue";
import { EventBus } from '../../../modules/eventBus';

export default {
  components: { RestablecerUsuario },
  data() {
    return {
      loading: false,
      nombre_empleado: '',
      ocupacion: null,
      estado: null,
      telefono: '',
      curp: '',
      rfc: '',
      correo: '',
      genero: null,
      fechaNacimiento: '',
      clienteDemo: null,
      clientesDemo: [],
      usuario: "",
      password: "",
      password1: "",
      emailRC: "",
      curpRC: "",
      clientes: [],
      clientes_autocomplete: [],
      token: this.$route.params.jwt,
      result: "d-none",
      bandera: false,
      classPass: "is-invalid",
      classPass1: "is-invalid",
      mostrar: true,
      mostrar1: false,
      mostrar2: false,
      tokenRest: "",
      validacionCorreo: false,
      validacionCurp: false,
      icono_Pass: "fas fa-eye",
      showConfigurationSection: true,
      configurationSectionContent: [],
      showAdvantagesSection: true,
      advantagesSectionContent: [],
      reglas: [
        {
          text: "Longitud de contraseña: minimo 8 caracteres",
          isValid: (value) => {
            if (value.length >= 8) {
              return true;
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres numericos: minimo 2 numeros",
          isValid: (value) => {
            let bandera = 0;
            for (let i = 0; i < value.length; i++) {
              if (/^[0-9]+$/.test(value.charAt(i))) {
                bandera++;
                if (bandera == 2) {
                  return true;
                }
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres de simbolos: minimo 1 caracter especial",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (!/[a-zA-Z0-9]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras mayúsculas: minimo 1 letra mayúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[A-Z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras minúsculas: minimo 1 letra minúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[a-z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
      ],
      estructura: {
        n2: '',
        n3: '',
        n4: '',
        puesto: '',
      },
      n2_array: [],
      n3_array: [],
      n4_array: [],
      puestos: [],
      n2Selected: '',
      filteredOptions: [],
      showSuggestions: false,
      empresa: '',
      showPuestos: false,
      isModalOpen: false,
      formData: {
        nombre_empleado: '',
        n2: '',
      },
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      excluir: ["--Seleccione--", "--Todos--", "--N/A--"],

    };
  },
  methods: {
    updateDimensions() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    openModal(link) {
      console.log('DEBUG: cia', this.cia);

      let videoWidth = 0;

      switch (this.cia.register_modal_video_tutorial_size) {
        case 'small':
          videoWidth = 320
          break;

        case 'medium':
          videoWidth = 640
          break;

        case 'large':
          videoWidth = 1280
          break;

        default:
        videoWidth = 320
          break;
      }
      Swal.fire({
        width: `1350px`,
        title: '',
        html: `
          <video style="width: 1230px" autoplay controls>
            <source src="${link}" type="video/mp4">
            Tu navegador no soporta el elemento de video.
          </video>
        `,
        confirmButtonText: 'Cerrar'
      });

    },
    closeModal() {
      this.isModalOpen = false;
    },
    selectOption(option) {
      this.empresa = option.label; // Asigna la opción seleccionada
      this.estructura.n4 = option.label; // Asigna la opción seleccionada
      this.showSuggestions = false; // Oculta la lista
      this.showPuestos = true;
      this.obtenerPuestos();
    },
    emitLogin() {
      EventBus.$emit('user-logged-in', true);
    },
    onN2Change(event) {
      this.showSuggestions = false;
      this.estructura.n4 = '';
      if (event.target.value == '') {
        this.n3_array = [];
        this.puestos = [];
        return;
      };
      this.Consultar_N3();
    },
    onN3Change(event) {
      this.showSuggestions = false;
      this.estructura.n4 = '';
      this.n4_array = [];
      this.puestos = [];
      this.showPuestos = false;
      if (event.target.value == '') {
        return;
      };
      this.Consultar_N4();
    },
    onN4Change() {
      // this.showPuestos = this.estructura.n4 != '' && this.empresa.length > 0;
      this.puestos = [];
      this.showPuestos = false;
      this.estructura.n5 = null;
      this.estructura.puesto = null;
      if (this.estructura.n4.length >= 1) {
        this.filteredOptions = this.n4_array.filter((option) =>
          option.label.toLowerCase().includes(this.estructura.n4.toLowerCase())
        );
        console.log('DEBUG: this.filteredOptions', this.filteredOptions);
        // this.showSuggestions = this.filteredOptions.length > 0;
        this.showSuggestions = true;
      } else {
        this.showSuggestions = false;
        this.showPuestos = false;
      }
    },
    // onN4Change(event) {
    //   if (event.target.value == '') {
    //     this.puestos = [];
    //     return;
    //   };
    //   this.obtenerPuestos();
    // },
    Consultar_N2() {
      this.Cargando();
      this.n2_array = [];
      this.$http
        .get(
          "plan_capacitacion/capacitacion_institucional/alta_requerimientos/por_estructuras/combos/n2"
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          const filtrados = respuestaJson.filter(item => !this.excluir.includes(item.label));
          this.n2_array = filtrados;
        })
        .catch(error => {
          toastr.clear();
          toastr.error(
            this.$t("page.estructura_puestos_content.js_scope.problemas_n2")
          );
          this.Listo();
        });
    },
    Consultar_N3() {
      this.n3_array = [];
      this.estructura.n3 = "";
      if (!isNaN(this.estructura.n2)) {
        this.$http
          .get(
            "plan_capacitacion/capacitacion_institucional/alta_requerimientos/por_estructuras/combos/n3/" +
              this.estructura.n2
          )
          .then(respuesta => {
            return respuesta.json();
          })
          .then(respuestaJson => {
            const filtrados = respuestaJson.filter(item => !this.excluir.includes(item.label));
            this.n3_array = filtrados;
          })
          .catch(error => {
            toastr.clear();
            toastr.error(
              this.$t("page.estructura_puestos_content.js_scope.problemas_n3")
            );
          });
      } else if (this.estructura.n2 == "--N/A--") {
        this.n3_array = new Array(
          {
            value: "--Todos--",
            label: "--Todos--"
          },
          {
            value: "--N/A--",
            label: "--N/A--"
          }
        );
      }
    },
    Consultar_N4() {
      this.n4_array = [];
      this.estructura.n4 = "";
      if (!isNaN(this.estructura.n3)) {
        this.$http
          .get(
            "plan_capacitacion/capacitacion_institucional/alta_requerimientos/por_estructuras/combos/n4/" +
              this.estructura.n3
          )
          .then(respuesta => {
            return respuesta.json();
          })
          .then(respuestaJson => {
            this.n4_array = respuestaJson;
            this.n4_array.splice(0, 2);
            // if (this.n4_array.length > 0 && this.estructura.n3 == '1') {
            //   this.estructura.n4 = this.n4_array[0].value;
            //   this.obtenerPuestos();
            // }
            //this.Listo();
          })
          .catch(error => {
            toastr.clear();
            toastr.error(
              this.$t("page.estructura_puestos_content.js_scope.problemas_n4")
            );
          });
      } else if (this.estructura.n3 == "--N/A--") {
        this.n4_array = new Array(
          {
            value: "--Todos--",
            label: "--Todos--"
          },
          {
            value: "--N/A--",
            label: "--N/A--"
          }
        );
      }
    },
    obtenerPuestos() {
      this.puestos = [];
      if (this.estructura.n3 == '') {
        return;
      }

      const cve_planta = this.n4_array.find(n4 => n4.label == this.estructura.n4);
      console.log('DEBUG: cve_planta', cve_planta);

      const body = {
          cve_area_manager: this.estructura.n2,
          cve_pais: this.estructura.n3,
          cve_planta: cve_planta.value,
      }

      console.log('DEBUG: body', body);

      this.$http
        .post(
          "catalogos/estructura_puestos/obtenerPuestos", body
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.puestos = respuestaJson.map(puesto => {
            return {
              value: puesto.cve_puesto, label: puesto.puesto
            }
          });
        })
        .catch(error => {
          toastr.clear();
          toastr.error(
            this.$t("page.estructura_puestos_content.js_scope.problemas_n3")
          );
        });
    },
    submitForm() {
      this.$refs.myForm.requestSubmit();
    },
    onlyNumbers(event) {
      // Verificar si el carácter es un número
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault(); // Prevenir que se inserte el carácter
      }
    },
    validarSoloAlfanumerico(campo) {
      // Eliminar caracteres especiales, solo permite letras y números
      this[campo] = this[campo].replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    },
    crearUsuario() {

      const form = this.$refs.myForm;

      console.log('DEBUG: validity', form.checkValidity());
      if (!form.checkValidity()) {
        form.reportValidity(); // Muestra mensajes de validación del navegador
        return;
      }


      this.loading = true;

      const n2 = this.n2_array.find(n2 => n2.value == this.estructura.n2);
      const n3 = this.n3_array.find(n3 => n3.value == this.estructura.n3);
      const puesto = this.puestos.find(puesto => puesto.value == this.estructura.puesto);


      const body = {
        N2: n2.label,
        N3: n3.label,
        N4: this.estructura.n4,
        N5: puesto.label,
        N6: "WEB",
        N7: "WEB",
        Puesto: puesto.label,
        NumEmpleado: -1,
        NombreEmpleado: this.nombre_empleado,
        FechaIngreso: this.getCurrentDate(),
        IDTarjeta: null,
        JEFE: "0",
        GENERO: this.genero,
        EMP_MAIL: this.correo,
        EMP_CURP: this.curp,
        EMP_RFC: this.rfc,
        TipoDeEmpleado: "0",
        FechaNacimiento: this.fechaNacimiento,
        FechaInicioPuesto: this.getCurrentDate(),
        Activo: "SI",
        Perfiles: "Participante",
        Telefono: this.telefono,
        nombre_cia: this.cia.nomcia,
        cia_logo: this.cia.logo,
        color_fondo: this.cia.color_fondo_header,
        cia_url: window.location.origin,
        estado: this.estado,
        cve_puesto: puesto.value,
      };

      console.log('DEBUG: body', body);

      this.$http
        .post("lms/empleados/alta", body, {
          headers: {
            Authorization: `Bearer ${this.erpApiKey}`
          }
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.loading = false;

          if (respuestaJson.resp) {
            let mensaje = `Hemos enviado un correo electrónico con los detalles de tu cuenta. Por favor, revisa tu bandeja de entrada (y la carpeta de correo no deseado, si no lo ves en la principal) para encontrar el mensaje.`;

            // Agregar información del método de acceso si no llega el correo
            if (this.cia.register_password_method) {
              mensaje += `\n\nSi no recibes el correo, para tu primer acceso, utiliza tu correo tanto para usuario y contraseña. Una vez dentro del sistema, se te solicitará cambiar tu contraseña por seguridad.`;
            }

            swal(
              "Excelente",
              mensaje,
              "success"
            );
            this.$refs['my-modal'].hide();
          } else {
            swal(
              respuestaJson.message,
              "",
              "error"
            );
          }
        })
        .catch(function (error) {
          this.loading = false;
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (2)",
            "error"
          );
          toastr.error(
            "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
          );
        });
    },
    getApiKeys() {
      this.$http
        .get("apis")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.erpApiKey = respuestaJson[0].token;
          localStorage.setItem('erp-api-key', this.erpApiKey)
        });
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript van de 0 a 11, por eso sumamos 1
      const day = String(now.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    showRegisterModal() {
      this.$refs['my-modal'].show();
    },
    showVideoModal() {
      this.$refs['video-modal'].show();
    },
    getCurrentYear() {
      const date = new Date();
      return date.getFullYear();
    },
    mostrarContrasena() {
      var tipo = document.getElementById("Password");
      if (tipo.type == "password") {
        tipo.type = "text";
        this.icono_Pass = "fas fa-eye-slash";
      } else {
        tipo.type = "password";
        this.icono_Pass = "fas fa-eye";
      }
    },
    recuperarContrasena() {
      let that = this;
      let data = VueJwtDecode.decode(this.token).data;
      let bandera = false;
      let bandera1 = false;

      if (
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
          this.emailRC
        )
      ) {
        bandera = true;
        this.validacionCorreo = false;
      } else {
        this.validacionCorreo = true;
      }

      if (/^([a-zA-Z0-9_-]){1,100}$/.test(this.curpRC)) {
        if (this.curpRC.indexOf("-", 0) == -1) {
          if (this.curpRC.indexOf("_", 0) == -1) {
            bandera1 = true;
            this.validacionCurp = false;
          } else {
            this.validacionCurp = true;
          }
        } else {
          this.validacionCurp = true;
        }
      } else {
        this.validacionCurp = true;
      }

      if (bandera && bandera1) {
        this.$http
          .post("usuarios/restablecerContrasena", {
            email: this.emailRC,
            curp: this.curpRC,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(
                respuestaJson.resp,
                "Hemos enviado a tu correo las instrucciones para tu cambio de contraseña",
                "success"
              );
              setTimeout(() => {
                that.regresarInicio();
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Restablecer_Contraseña", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            that.Listo();
          });
        that.Listo();
      }
    },
    enviarNuevasCredenciales() {
      let that = this;
      let data = VueJwtDecode.decode(this.token).data;
      if (
        this.password === this.password1 &&
        this.password != data.cve_empleado
      ) {
        this.$http
          .post("usuarios/restablecerUsuario", {
            password: this.password,
            cve_empleado: data.cve_empleado,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(respuestaJson.resp, "Usuario actualizado", "success");
              setTimeout(() => {
                that.$router.push({ name: "Login" });
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Iniciar_Sesion", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            that.Listo();
          });
      } else {
        if (this.password == data.cve_empleado) {
          swal(
            "Error de datos",
            "Favor de revisar que la contraseña no sea igual al numero de usuario: " +
              data.cve_empleado,
            "error"
          );
        } else {
          swal(
            "Error de datos",
            "Favor de revisar que las contraseñas coincidan",
            "error"
          );
        }
        that.Listo();
      }
    },
    changePass() {
      this.mostrar = false;
      this.mostrar2 = true;
    },

    regresarInicio() {
      this.mostrar = true;
      this.mostrar1 = false;
      this.validacionCorreo = false;
      this.validacionCurp = false;
    },
    regresarInicio2() {
      this.mostrar2 = false;
      this.mostrar = true;
    },
    recoverPassword() {
      this.mostrar = false;
      this.mostrar1 = true;
    },
    Cargando() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").show();
        that.result = "d-none";
      });
    },
    Listo() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").hide();
        that.result = "";
      });
    },
    async Iniciar_Sesion() {
      var that = this;
      let aprobado = false;
      this.Cargando();
      let httpEl = {};
      if (this.esDemo) {
        if (this.clienteDemo != null) {
          aprobado = true;
          httpEl = {
            navegador: this.menu.navegador,
            sistema_operativo: this.menu.sistema_operativo,
            empresa: this.empresa,
            usuario: this.usuario,
            password: this.password,
            tokenfcm: this.firebase_config.tokenfcm,
            clienteDemo: this.clienteDemo,
          };
        }
      } else {
        aprobado = true;
        httpEl = {
          navegador: this.menu.navegador,
          sistema_operativo: this.menu.sistema_operativo,
          empresa: this.empresa,
          usuario: this.usuario,
          password: this.password,
          tokenfcm: this.firebase_config.tokenfcm,
        };
      }

      if (aprobado) {
        this.$http
          .post("login", httpEl)
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            var pasar = "Si";

            if (respuestaJson.resp == "Excelente") {
              var usuario_datos = VueJwtDecode.decode(respuestaJson.jwt);
              localStorage.setItem('test', JSON.stringify(usuario_datos));
              this.$store.state.menu.usuario = usuario_datos.data;
              this.$store.state.menu.token = respuestaJson.jwt;
              this.Actualizar_Usuario(usuario_datos.data, respuestaJson.jwt);
              this.login();
              this.emitLogin();
              console.log('DEBUG: apikeyantes', localStorage.apiKey_lms);
              localStorage.removeItem("apiKey_lms");
              localStorage.apiKey_lms = JSON.stringify(respuestaJson.jwt);
            } else {
              if (respuestaJson.resp == "Cambio de credenciales") {
                that.tokenRest = respuestaJson.jwt;
                that.changePass();
                that.Listo();
              } else if (respuestaJson.resp.includes("ocupada")) {
                that.Listo();
                toastr.error(
                  "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
                );
                swal(
                  respuestaJson.resp,
                  "Por favor intenta mas tarde.",
                  "error"
                );
              } else {
                that.Listo();
                toastr.error(
                  "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
                );
                swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
              }
            }
          })
          .catch(function (error) {
            console.log("Error en Iniciar_Sesion", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            toastr.error(
              "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
            );
            that.Listo();
          });
      } else {
        that.Listo();
        toastr.error("Selecciona la entidad por favor");
      }
    },
    ConsultarClientes: function () {
      var that = this;
      this.Cargando();
      this.$http
        .post("clientes", {
          empresa: this.empresa,
          usuario: this.usuario,
          password: this.password,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          var pasar = "Si";

          if (respuestaJson.resp == "Excelente") {
            var usuario_datos = VueJwtDecode.decode(respuestaJson.jwt);
            this.$store.state.menu.usuario = usuario_datos.data;
            this.$store.state.menu.token = respuestaJson.jwt;
            this.Actualizar_Usuario(usuario_datos.data, respuestaJson.jwt);
            localStorage.removeItem("apiKey_lms");

            localStorage.apiKey_lms = JSON.stringify(respuestaJson.jwt);
          } else {
            that.Listo();
            swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
          }
        })
        .catch(function () {
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
          that.Listo();
        });
    },
    ConsultarClientesDemo: function () {
      var that = this;
      this.Cargando();
      this.$http
        .get("https://lmsedk.com/DEMO/api/public/pub/getClientesDemo")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.clientesDemo = respuestaJson.clientesDemo;
        })
        .catch(function () {
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
          that.Listo();
        });
    },
    Seleccionar_Empresa(nombre_empresa) {
      for (var i = 0; i < this.clientes.length; i++) {
        if (this.clientes[i].nomcliente == nombre_empresa) {
          this.Actualizar_Empresa(this.clientes[i].idcliente);
        }
      }
    },
    autocomplete(inp, arr) {
      var that = this;
      that.inp = inp;
      that.arr = arr;
      $(document).ready(function () {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        var currentFocus;
        /*execute a function when someone writes in the text field:*/
        that.inp.addEventListener("input", function (e) {
          var a,
            b,
            i,
            val = this.value;
          /*close any already open lists of autocompleted values*/
          that.closeAllLists();
          if (!val) {
            return false;
          }
          currentFocus = -1;
          /*create a DIV element that will contain the items (values):*/
          a = document.createElement("DIV");
          a.setAttribute("id", this.id + "autocomplete-list");
          a.setAttribute("class", "autocomplete-items");
          /*append the DIV element as a child of the autocomplete container:*/
          this.parentNode.appendChild(a);
          /*for each item in the array...*/
          for (i = 0; i < that.arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (
              that.arr[i].substr(0, val.length).toUpperCase() ==
              val.toUpperCase()
            ) {
              /*create a DIV element for each matching element:*/
              b = document.createElement("DIV");
              /*make the matching letters bold:*/
              b.innerHTML =
                "<strong>" + that.arr[i].substr(0, val.length) + "</strong>";
              b.innerHTML += that.arr[i].substr(val.length);
              /*insert a input field that will hold the current array item's value:*/
              b.innerHTML +=
                "<input type='hidden' value='" + that.arr[i] + "'>";
              /*execute a function when someone clicks on the item value (DIV element):*/
              b.addEventListener("click", function (e) {
                /*insert the value for the autocomplete text field:*/
                that.inp.value = this.getElementsByTagName("input")[0].value;
                that.Seleccionar_Empresa(
                  this.getElementsByTagName("input")[0].value
                );
                /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                that.closeAllLists();
              });
              a.appendChild(b);
            }
          }
        });
        /*execute a function presses a key on the keyboard:*/
        that.inp.addEventListener("keydown", function (e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
              increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            that.addActive(x);
          } else if (e.keyCode == 38) {
            //up
            /*If the arrow UP key is pressed,
              decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            that.addActive(x);
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click();
            }
          }
        });
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
          that.closeAllLists(e.target);
        });
      });
    },
    addActive(x) {
      var that = this;
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      that.removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    },
    removeActive(x) {
      var that = this;
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    },
    closeAllLists(elmnt) {
      var that = this;
      /*close all autocomplete lists in the document,
      except the one passed as an argument:*/
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != that.inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    },
    Definir_Token_Generico() {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(that.token);
      this.Listo();
    },
    Validar_Token() {
      var that = this;

      if (localStorage.getItem("apiKey_lms")) {
        if (JSON.parse(localStorage.apiKey_lms).length > 100) {
          var token = VueJwtDecode.decode(JSON.parse(localStorage.apiKey_lms));

          if (token.data.cve_empleado != "Generico") {
            this.$http
              .get("usuarios/login/" + token.data.cve_empleado)
              .then((respuesta) => {
                return respuesta.json();
              })
              .then((respuestaJson) => {
                if (respuestaJson.length > 0) {
                  this.Actualizar_Usuario(
                    respuestaJson[0],
                    respuestaJson[0].token
                  );
                } else {
                  that.Definir_Token_Generico();
                }
              })
              .catch((error) => {
                that.Definir_Token_Generico();
              });
          } else {
            that.Definir_Token_Generico();
          }
        } else {
          that.Definir_Token_Generico();
        }
      } else {
        that.Definir_Token_Generico();
      }
    },
    Consultar_Token_Generico() {

      var that = this;
      this.$http
        .get("../pub/token/generico")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.token != undefined) {
            that.token = respuestaJson.token;
            that.Actualizar_TokenGenerico(that.token);
            that.Validar_Token();
          } else {
            that.Definir_Token_Generico();
            swal(
              "Problemas con el servidor",
              "Favor de intentar mas tarde",
              "error"
            );
          }
        })
        .catch((error) => {
          that.Definir_Token_Generico();
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (3)",
            "error"
          );
        });
    },
    Actualizar_Usuario(usuario, token) {
      var that = this;
      localStorage.setItem('perfil_sistema', usuario.perfil_sistema);
      this.$store
        .dispatch("Actualizar_Usuario", { usuario: usuario, token: token })
        .then((data) => {
          that.Validar_Permisos(token);
        });
    },
    Validar_Permisos(token) {
      var that = this;
      this.$store.dispatch("Definir_Opciones_Menu_Lateral").then((data) => {
        that.Continuar_Menu(token);
      });
    },
    Continuar_Menu(token) {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(token);
      this.$router.push({ name: "Menu", params: { origin: "Login" } });
    },
    ...mapActions(["Actualizar_TokenGenerico", "Actualizar_Empresa", 'login']),
  },
  watch: {
    formData: {
      handler() {
        console.log('DEBUG: formData', this.formData);
        // Cuando los datos cambian, comprobamos la validez
        this.$nextTick(() => {
          this.isFormValid; // Actualizamos la validación del formulario
        });
      },
      deep: true,  // Esto permite observar los cambios dentro de objetos anidados
    },
    clientes_autocomplete: function (newValue, oldValue) {
      var that = this;
      //that.autocomplete(document.getElementById("myInput"), that.clientes_autocomplete);
    },
    password: function () {
      this.reglas.forEach((element) => {
        if (element.isValid(this.password)) {
          element.class = "text-success";
          return element;
        } else {
          element.class = "text-danger";
          return element;
        }
      });
      let rest = this.reglas.filter((element) => {
        return !element.isValid(this.password);
      });
      if (rest.length > 0) {
        this.classPass = "is-invalid";
      }
      if (rest.length == 0) {
        this.classPass = "is-valid";
      }
    },
    password1() {
      if (this.password == this.password1) {
        this.classPass1 = "is-valid";
      } else {
        this.classPass1 = "is-invalid";
      }
    },
  },
  computed: {
    isFormValid() {
      this.formData = {
        nombre_empleado: this.nombre_empleado,
        n2: this.estructura.n2,
        n3: this.estructura.n3,
        n4: this.estructura.n4,
        puesto: this.estructura.puesto,
        estado: this.estado,
        telefono: this.telefono,
        curp: this.curp,
        rfc: this.rfc,
        correo: this.correo,
        fechaNacimiento: this.fechaNacimiento,
        genero: this.genero,
      };

      if (!this.estructura.puesto) {
        return false;
      }

      const form = this.$refs.myForm;
      return form && form.checkValidity();
    },
    esDemo() {
      return this.$http.options.url.includes("/DEMO/api/public");
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    firebase_config() {
      return this.$store.getters.getFirebase_Config;
    },
    cia() {
      const cia = this.$store.getters.getCia;
      this.showConfigurationSection = cia['show_configuration_section'] == '1' ? true : false;
      this.showAdvantagesSection = cia['show_advantages_section'] == '1' ? true : false;
      const configurationSectionContent = cia.configuration_section_content;
      const advantagesSectionContent = cia.advantages_section_content;

      if (!!configurationSectionContent) {
        const cleanString = configurationSectionContent.replace(/\r\n/g, '').replace(/,\s*}/g, '}');
        const jsonArray = JSON.parse(cleanString);
        this.configurationSectionContent = jsonArray;
      } else {
        this.showConfigurationSection = false;
      }

      if (!!advantagesSectionContent) {
        const cleanString = advantagesSectionContent.replace(/\r\n/g, '').replace(/,\s*}/g, '}');
        const jsonArray = JSON.parse(cleanString);
        this.advantagesSectionContent = jsonArray;
      } else {
        this.showAdvantagesSection = false;
      }
      return cia;
    },
    enMantenimiento() {
      return String(this.$store.getters.getCia.plataforma_en_mantenimiento) === "1";
    },
  },
  created() {
    this.Consultar_Token_Generico();
    if (this.esDemo) {
      this.ConsultarClientesDemo();
    }
    //this.ConsultarClientes();
    this.getApiKeys();
    this.Consultar_N2();
  },
  mounted() {
    var that = this;
    $("#customizer_color_menu").addClass("d-none");
    $("#ze-snippet").remove();
    window.addEventListener('resize', this.updateDimensions);
    /*
    if (that.clientes_autocomplete!=null) {
      that.autocomplete(document.getElementById("myInput"), that.clientes_autocomplete);
    }
    */
  },
  beforeUnmount() { // o beforeDestroy en Vue 2
    window.removeEventListener('resize', this.updateDimensions);
  },
};
</script>

<style scoped>
/**
  ////////FAMILY FONTS//////

 */
/* .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
} */

.disclaimer {
  margin-top: 3%;
  margin-right: 3%;
  text-align: justify;
}

#parentHeaders {
  padding-left: 2em;
  padding-right: 2em;
}
#header2 {
  line-height: 40px;
  height: 50px !important;
  text-align: right;
}
#logo-header {
  margin-left: 1em;
}
input[type="radio"] {
  display: none;
}
label {
  font-family: "Trade Gothic LT";
  display: inline-block;
  font-weight: 100;
  opacity: 0.7;
}
#contentTOP {
  padding-top: 40px;
  position: relative;
}
#logo-header {
  width: auto;
  height: 49px;
  margin-bottom: 1.5em;
}
/* @media (min-width: 1024px) and (max-width: 1365px) {
  #logo-header {
    width: 98px;
    height: 34px;
  }
} */

#section1 {
  margin: 0;
  height: auto;
  width: 100%;
  background-size: cover;
}

@media (max-width: 1366px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 15px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 1023px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0px;
  }
}
.spanHeader {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-left: 20px;
}

#spanPlataformaServicios {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
}

.initView .row {
  margin-left: 0;
  margin-right: 0;
}
.contenedorTitulosLogin {
  margin-top: 0;
  margin-bottom: 0;
  height: 500px;
  padding-left: 0;
  padding-right: 0;
  height: 77vh;
  width: 87vw;
}
@media (min-width: 1023px) {
  .contenedorTitulosLogin {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.box {
  position: relative;
  height: 67vh;
  width: 87vw;
  margin: 0;
  margin-top: 10px;
  padding: 0;
  border-style: solid;
  border-width: 0.05em;
  border-color: white;
  border-radius: 0;
}

/* @media only screen and (min-width: 1000px) {
  .box {
    margin: 0;
    margin-top: 45px;
  }
} */

.top,
.bottom,
.left,
.right {
  position: absolute;
  -webkit-animation: 8s linear;
  -moz-animation: 8s linear;
  -o-animation: 8s linear;
  animation: 8s linear;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0.5;
}

.top {
  top: 0;
  left: 0;
  height: 1px;
  -webkit-animation-name: top;
  -moz-animation-name: top;
  -o-animation-name: top;
  animation-name: top;
}
.bottom {
  bottom: 0;
  right: 0;
  height: 1px;
  -webkit-animation-name: bottom;
  -moz-animation-name: bottom;
  -o-animation-name: bottom;
  animation-name: bottom;
}
.left {
  bottom: 0;
  left: 0;
  width: 1px;
  -webkit-animation-name: left;
  -moz-animation-name: left;
  -o-animation-name: left;
  animation-name: left;
}
.right {
  top: 0;
  right: 0;
  width: 1px;
  -webkit-animation-name: right;
  -moz-animation-name: right;
  -o-animation-name: right;
  animation-name: right;
}
.contenedorTexto {
  padding-top: 80px;
  margin-bottom: 40px;
  padding-left: 5%;
  float: left;
  width: 100%;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1023px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 992px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}
@media (min-width: 700px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}

#svgContent {
  width: 2%;
  padding: 0;
  padding-top: 6px;
}
#arrowSVG {
  fill: white;
}
.contenedorTexto2,
#svgContent {
  margin-bottom: 40px;
  padding-top: 5px;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto2 {
    margin-bottom: 40px;
  }
}

h1 {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 75px;
  line-height: 80px;
  letter-spacing: -1px;
}

.titleLoginContainer {
  display: block;
  position: absolute;
  right: 55%;
  width: 425px;
  bottom: 105px;
}


.contenedorLogin {
  display: block;
  position: absolute;
  background-size: cover;
  right: 13%;
  width: 425px;
  bottom: -10px;
  background-color: #3e3e3e;
  padding-bottom: 2em;
}
#mantenimientoform {
  box-sizing: border-box;
  height: 332px;
  min-height: 332px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mantenimiento-contenido {
  width: 100%;
  padding: 0 8%;
  text-align: center;
  color: #fff;
}
.mantenimiento-icono {
  display: block;
  font-size: 42px;
  line-height: 1;
  margin-bottom: 18px;
  color: #fff;
}
.mantenimiento-titulo {
  display: block;
  font-family: "Trade Gothic LT";
  font-size: 26px;
  line-height: 1.2;
  margin-bottom: 14px;
}
.mantenimiento-texto {
  margin: 0;
  color: #fff;
  font-family: "Trade Gothic LT";
  font-size: 18px;
  line-height: 1.45;
}
.contenedorLogin2 {
  display: block;
  position: absolute;
  background-size: cover;
  right: 13%;
  width: 425px;
  bottom: 320px;
  padding-bottom: 2em;
}

.nuevoDiv {
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  color: white;
}

.innerDiv {
  width: 75%;
  background-color: #3e3e3e;
  padding: 10px;
  box-sizing: border-box;
  text-align: end;
}

.registro a {
  color: cornflowerblue; /* Color del texto del enlace */
}

.registro a:hover {
  color: cornflowerblue; /* Mantiene el mismo color en estado hover */
  cursor: pointer;
}

@media (max-width: 1140px) {
  .titleLoginContainer {
    display: block;
    position: absolute;
    right: 15%;
    width: 405px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 4em !important;
  }
  .contenedorLogin {
    right: 23%;
  }
  .contenedorLogin2 {
    right: 23%;
  }
}
@media (max-width: 850px) {
  .titleLoginContainer h1 {
    font-size: 3.5em !important;
  }
  .titleLoginContainer {
    right: 8%;
  }
  .contenedorLogin {
    right: 20%;
  }
  .contenedorLogin2 {
    right: 20%;
  }
}
@media (max-width: 690px) {
  .titleLoginContainer {
    right: -4%;
  }
  .contenedorLogin {
    right: 11%;
  }
  .contenedorLogin2 {
    right: 11%;
  }
}
@media (max-width: 570px) {
  .titleLoginContainer {
    right: 15%;
    width: 265px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 3em !important;
  }
  .contenedorLogin {
    right: 10%;
    width: 370px;
  }
  .contenedorLogin2 {
    right: 10%;
    width: 370px;
  }
  #header2 {
    right: 7% !important;
  }
  /* #btnIngresar {
    display: block;
    position: absolute;
    right: 65% !important;
  } */
}

@media (max-width: 420px) {
  .titleLoginContainer {
    right: 18%;
    width: 205px;
    bottom: 280px;
    font-size: 1em !important;
  }
  .titleLoginContainer h1 {
    font-size: 3em !important;
  }
  .contenedorLogin {
    right: 4%;
    width: 300px;
  }
  .contenedorLogin2 {
    right: 4%;
    width: 300px;
  }
  #header2 {
    right: 7% !important;
  }
  /* #btnIngresar {
    display: block;
    position: absolute;
    right: 60% !important;
  } */
  #problemasLOGIN {
    padding-left: 3em;
  }
}

/* @media only screen and (min-width: 1224px) {
  .contenedorLogin {
    bottom: -20px;
  }
}
@media (min-width: 992px) {
  .contenedorLogin {
    bottom: -60px;
  }
}
@media (min-width: 700px) {
  .contenedorLogin {
    bottom: -20px;
  }
} */

#contentSpanIngreseCuenta {
  padding-top: 25px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 25px;
}

#spanIngreseCuenta {
  font-family: Trade Gothic LT;
  font-size: 21px;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
}

#spanIngreseCuentaTexto {
  font-family: Trade Gothic LT;
  margin-top: 5px;
  font-size: 13px;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
}

#loginDiv {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 20px;
}

.textLoginPlaceholder {
  color: rgba(255, 255, 255, 0.9) !important;
  border-radius: 2px;
  border-top-right-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: none;
  height: 40px;
  width: 100%;
  padding: 6px 12px;
  font-family: "Trade Gothic LT Bold No. 2";
}
.textLoginPlaceholder1 {
  color: rgba(255, 255, 255, 0.9) !important;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-right: 0px;
  background: none;
  height: 40px;
  width: 88%;
  padding: 6px 12px;
  font-family: "Trade Gothic LT Bold No. 2";
}
@media (max-width: 575.98px) {
  .textLoginPlaceholder1 {
    width: 84%;
  }
}

.textLoginPlaceholder::placeholder {
  color: #fff !important;
}

.textLoginPlaceholder1::placeholder {
  color: #fff !important;
}

#btn_Mostrar_Password {
  border: 1px solid white;
  border-left: 0px;
  box-shadow: none;
  border-top-right-radius: 4px;
  color: white;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.btnFullWhite {
  height: 42px;
  border-radius: 25px;
  width: 200px;
  /* padding: 0px; */
  background-color: white;
  color: #ff3300;
  outline: none;
  font-weight: 600;
  text-transform: uppercase;
}
.spanLinkLogin {
  font-family: "Trade Gothic LT";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1em !important;
}
@media (max-width: 1366px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 17px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 9px;
    line-height: 13px;
    letter-spacing: 0px;
  }
}

.contenedorMainFunctions {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #fff;
}

#spanFuncionesPrincipales {
  color: black;
  font-size: 50px;
  font-family: "Trade Gothic LT Bold Condensed";
}

.subtitulos2 {
  color: #7b7b7b;
  font-size: 18px;
  line-height: 1.39;
  font-family: "Trade Gothic LT";
}

@media (min-width: 700px) {
  .subtitulos2 {
    font-size: 18px;
  }
}

.contenedorConfiguracion {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #f6f6f6;
}

.contenedorConfiguracion h5 {
  font-family: "Trade Gothic LT Bold No. 2";
}
.contenedorConfiguracion .col-xs-4 {
  padding-left: 2em;
  padding-right: 2em;
}

@media (min-width: 1366px) and (max-width: 1920px) {
  .contenedorConfiguracion h5 {
    font-size: 45px;
    line-height: 48px;
    letter-spacing: -1.5px;
  }
}

@media (min-width: 768px) {
  .contenedorConfiguracion h5 {
    font-size: 30px;
    line-height: 30px;
    letter-spacing: -1.5px;
  }
}

.backgroundNegro {
  height: auto;
  position: relative;
  width: 100%;
  right: 0;
  float: left;
  padding: 6% 6% 11%;
}

.ventajas {
  color: #fff;
  font-size: 45px;
  font-family: "Trade Gothic LT Bold Condensed";
}
.subtitulos {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 20px;
  position: absolute;
  width: 15em;
  top: 55px;
}
.textoAdvantages {
  font-family: "Trade Gothic LT Bold Condensed";
  color: #2f3339;
  font-size: 140px;
}
.body3 {
  font-family: "Trade Gothic LT";
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  position: absolute;
  width: 15em;
  top: 95px;
}
.contenedorFooter {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
  color: white;
}

.spanFooter {
  cursor: pointer;
  font-family: "Trade Gothic LT";
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
  color: white;
}
@media (max-width: 1366px) {
  .spanFooter {
    font-size: 0.8em;
  }
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 1023px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 768px) {
  .spanFooter {
    font-size: 12px;
  }
}

.logo-footer {
  width: 151.3px;
}
#container_login {
  text-transform: none;
}

.logo-footer {
  vertical-align: middle;
}
.logo-footer {
  border: 0;
}

.cuadrosText {
  margin-bottom: 3rem;
  padding-right: 2em;
  padding-left: 2em;
}
.text-white {
  height: 2em;
  background-color: #fff;
}
.col-margin {
  width: 2em;
}

input:-webkit-autofill {
  -webkit-background-clip: text;
  -webkit-text-fill-color: white;
}
.justify-content-md-center {
  justify-content: center !important;
}
#textMARK {
  text-transform: none !important;
}
#problemasLOGIN {
  cursor: default;
  font-size: 1.5em;
}
#to-recover {
  text-decoration-line: underline;
}
/* .optionLoginSelector {
  background-color: #1e253300;
} */

#clienteFormControlSelect {
  background-color: rgba(34, 34, 34, 0);
  border-radius: 0 !important;
}
#clienteFormControlSelect option {
  background-color: #ff33007a;
  font-size: 1.2em;
  color: #ffffff !important;
}
.no-border {
  border: none !important;
}

.autocomplete-container {
  position: relative;
}

.suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
  /* position: absolute; */
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
}

.suggestions li {
  padding: 8px;
  cursor: pointer;
}

.suggestions li:hover {
  background: #f0f0f0;
}
.modal-registro{
  color: black !important;
}

strong {
  font-weight: bold;
}
.modal-title {
  color: black
}
.video-container {
  width: 620 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLogin/Login/Login.vue